export default function Note({ title, copy }: { title: string; copy: string }) {
  return (
    <div className="bg-surface-5 bg-surface-extended-blue-transparent-light rounded-md p-4 ps-8 mb-8 border-l-2 border-[var(--Surfaces-Extended-Blue-Transparent-Light)]">
      <h5 className="cs-h5 text-[var(--Text-Default-Strong)] pb-1">{title}</h5>
      <p className="cs-s-body-regular text-[var(--Text-Default-Medium)]">{copy}</p>
    </div>
  );
}
